module.exports = __webpack_public_path__ + "static/home-page-video-de9555d0d3249c72a743b3c6b14a80e6.mp4";